import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const deletePromptConfirmationModalStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		maxWidth: '400px',
		minWidth: '300px',
	},
	modalBody: {
		height: '100%',
		padding: { xs: '32px 24px', [tabletBreakpoint]: '32px 65px' },
		borderWidth: '1px',
		borderStyle: 'solid',
		borderColor: 'colors.dark1',
		borderRadius: '8px',

		backgroundColor: 'colors.dark6',

		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		gap: '20px',

		position: 'relative',
	},
	buttonsCont: {
		width: '100%',

		display: 'flex',
		flexDirection: { xs: 'column', [tabletBreakpoint]: 'row' },
		gap: '16px',
		alignItems: 'center',
	},
	button: {
		width: '100%',
		maxWidth: '172px',
		padding: '0px 16px',
		borderRadius: '4px',
		borderWidth: '1px',
		borderStyle: 'solid',
		textTransform: 'none',
		height: '32px',
	},
	cancelButton: {
		borderColor: 'colors.light5',

		color: 'colors.light1',
		backgroundColor: 'colors.dark5',
		'&:hover': {
			backgroundColor: 'colors.dark5',
		},
	},
};

export { deletePromptConfirmationModalStyles };
